var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('virtual-list',{ref:"vsl",staticClass:"list-infinite scroll-touch",attrs:{"data-key":_vm.dataKey,"data-sources":_vm.getSources(),"data-component":_vm.getWrapper(),"estimated-size":_vm.estimated,"page-mode":true}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afd4c73c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/sharedcomponents/VirtualScrollList.vue
// module id = null
// module chunks = 